export default "__VITE_ASSET__Bez9NhfC__"